<div class="wrapper">
	<div class="header-wrapper">
		<h2 class="title">{{ 'select_products_promo' | translate }}</h2>
		<!-- <p class="description">
      {{ 'recom_art.desc' | translate }}
    </p> -->
	</div>
	<div class="content_block" role="region" aria-label="Content block">
		<ion-row>
			<ng-container *ngFor="let article of articlesList; let i = index; trackBy: trackBy">
				<ion-col size="6" *ngIf="article?.isActive && article?.visible">
					<div class="card-item" [class.selected]="showAmount(article) > 0" role="region" aria-label="Card item">
						<ion-icon
							[class.active]="showAmount(article) > 0"
							src="../../../assets/dean_and_david/selected_item.svg"
							class="selected_item_icon"
							role="img"
							aria-label="Icon representing the article amount"
						>
						</ion-icon>
						<p class="price">
							{{ numberToCurrency(0, this.order?.currency) }}
						</p>
						<div class="image-block">
							<ion-img class="item_img" *ngIf="article.assets.medium" [src]="article.assets.medium" alt=""></ion-img>
							<ion-img
								class="default-img"
								*ngIf="!article.assets.medium"
								src="../../../assets/dean_and_david/logo-big.png"
								alt=""
								aria-hidden="true"
							></ion-img>
							<ion-icon
								class="plus"
								[src]="
									article.assets.medium
										? '../../../assets/olearys/plus_recommended.svg'
										: '../../../assets/olearys/plus_recommended_white.svg'
								"
								role="img"
								aria-label="Add recommended"
							></ion-icon>
						</div>
						<div class="info-block" role="region" aria-label="Information block">
							<h3 class="name">
								{{ article.name | langObservable | async }}
							</h3>
						</div>
						<div class="footer-section" role="region" aria-label="Footer section">
							<div
								class="add-button"
								*ngIf="showAmount(article) === 0"
								(click)="selectArticle(article)"
								role="button"
								tabindex="0"
							>
								<p>{{ 'add_promo' | translate }}</p>
							</div>
							<div *ngIf="showAmount(article) > 0" class="quantity-selector" role="region" aria-label="Amount information">
								<ion-icon
									(click)="decreaseQuantity(article)"
									class="quantity-btn"
									src="../../../assets/dean_and_david/minus.svg"
									role="img"
									aria-label="Decrease quantity"
								></ion-icon>
								<p class="quantity">{{ showAmount(article) }}</p>
								<!-- <ion-icon
                class="quantity-btn"
                (click)="increaseQuantity(article)"
                src="../../../assets/dean_and_david/plus.svg"
                aria-label="Increase quantity"
                role="img"></ion-icon> -->
							</div>
						</div>
					</div>
				</ion-col>
			</ng-container>
		</ion-row>
	</div>

	<div class="footer-btn" role="button" tabindex="0">
		<!-- <ion-button (click)="addArticlesToBasket()">{{ 'recom_art.btn_yes' | translate
			}}</ion-button> -->
		<ion-button [disabled]="selectedArticles.length === 0" (click)="addArticlesToBasket()" class="cancel-btn">{{
			'add_promo_dialog.add' | translate
		}}</ion-button>
	</div>
</div>
